'use client';

import Image from 'next/image';
import { motion } from 'framer-motion';
import { useTheme } from 'next-themes';
import { useState, useEffect } from 'react';

export default function TrustedCompanies() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // After mounting, we can safely show the UI that depends on the theme
  useEffect(() => {
    setMounted(true);
  }, []);

  const companies = [
    {
      name: 'Fidelity',
      logo: '/logos/fidelity.svg',
      className: 'translate-y-0.5', // No adjustment needed
    },
    {
      name: 'Vanguard',
      logo: '/logos/vanguard.svg',
      className: 'translate-y-1', // No adjustment needed
    },
    {
      name: 'BlackRock',
      logo: '/logos/blackrock.svg',
      className: 'translate-y-0', // Slight downward adjustment
    },
    {
      name: 'JP Morgan',
      logo: '/logos/jp-morgan.svg',
      className: 'translate-y-1', // Very slight downward adjustment
    },
    {
      name: 'Morgan Stanley',
      logo: '/logos/morgan-stanley.svg',
      className: 'translate-y-1', // Very slight downward adjustment
    },
  ];

  return (
    <div className="w-full max-w-5xl mx-auto mt-16 md:mt-24 px-4 md:px-0">
      <p className="text-xs md:text-sm text-zinc-500 dark:text-zinc-400 mb-6 md:mb-8 text-center font-medium tracking-wide uppercase">
        Used by employees from
      </p>
      <div className="grid grid-cols-3 md:grid-cols-5 gap-4 md:gap-6 items-center justify-center">
        {companies.map((company, i) => (
          <motion.div
            key={i}
            className="flex items-center justify-center h-8 md:h-10"
            whileHover={{ y: -2 }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.05 }}
          >
            {mounted && (
              <div
                className={`h-6 md:h-8 w-auto flex items-center ${company.className}`}
              >
                <Image
                  src={company.logo || '/placeholder.svg'}
                  alt={`${company.name} logo`}
                  width={120}
                  height={40}
                  className={`h-full w-auto opacity-70 hover:opacity-100 transition-opacity [filter:brightness(0)_saturate(100%)] dark:[filter:brightness(0)_saturate(100%)_invert(1)]`}
                />
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
}
